import React from 'react';

const SIZE_MAP = {
  xs: 14,
  sm: 18,
  md: 28,
  lg: 36,
  xl: 48,
};

/**
 * Standardized Premium Spinner for Oblique 2.0
 * Uses the 'spin' animation defined in index.css
 */
const Spinner = ({ size = 24, color = 'var(--accent)', className = '', ...props }) => {
  const numericSize = typeof size === 'number' ? size : (!isNaN(Number(size)) ? Number(size) : (SIZE_MAP[size] || 24));

  return (
    <div
      className={`spinner-container ${className}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: `${numericSize}px`,
        height: `${numericSize}px`,
      }}
      {...props}
    >
      <svg
        width={numericSize}
        height={numericSize}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="spin"
        style={{ color, width: `${numericSize}px`, height: `${numericSize}px` }}
      >
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          style={{ opacity: 0.2 }}
        />
        <path
          d="M12 2C6.47715 2 2 6.47715 2 12C2 13.5997 2.37562 15.1116 3.03906 16.4531"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

export default Spinner;
